import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDemoSession } from '../../auth/DemoSessionProvider';
import { EntraSignInButton } from '../../auth/EntraSignInButton';
import { isDualAuth, isJwtAuth } from '../../auth/authMode';
import { isEntraConfigured } from '../../auth/entraConfig';
import { UmbLogo } from '../../components/layout/UmbLogo';

export function DemoSignInPage() {
  const { signInWithMicrosoft, setAuthError, authError } = useDemoSession();
  const showEmailLink = isJwtAuth();
  const [microsoftBusy, setMicrosoftBusy] = useState(false);

  return (
    <div className="flex min-h-screen items-center justify-center bg-eorig-surface px-4 py-10 font-sans text-eorig-ink [word-spacing:0.06em]">
      <div className="w-full max-w-xl">
        <div className="rounded-2xl border border-eorig-border bg-white p-6 shadow-eorig-card sm:p-8">
          <div className="flex items-start justify-between gap-3">
            <UmbLogo />
            <span className="inline-flex items-center rounded-full border border-eorig-border bg-eorig-surface px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-normal text-eorig-muted">
              {isDualAuth() ? 'Demo + secure sign-in' : 'Demo environment'}
            </span>
          </div>

          <h1 className="mt-6 text-2xl font-semibold tracking-normal text-eorig-ink">
            UMB eVault
          </h1>
          <p className="mt-2 text-sm leading-relaxed text-eorig-muted">
            Secure digital custody and authoritative document management
          </p>

          {isEntraConfigured() || showEmailLink ? (
            <div className="mt-6 space-y-3">
              {isEntraConfigured() ? (
                <EntraSignInButton
                  busy={microsoftBusy}
                  className="flex w-full items-center justify-center rounded-2xl border border-eorig-border bg-white px-4 py-3 text-sm font-semibold text-eorig-ink transition hover:bg-eorig-surface disabled:opacity-60"
                  onClick={async () => {
                    setMicrosoftBusy(true);
                    setAuthError?.(null);
                    try {
                      await signInWithMicrosoft();
                    } catch (err) {
                      setAuthError?.(err.message || 'Microsoft sign-in failed');
                      setMicrosoftBusy(false);
                    }
                  }}
                />
              ) : null}
              {showEmailLink ? (
                <Link
                  to="/signin/email"
                  className="flex w-full items-center justify-center rounded-2xl bg-umb-navy px-4 py-3 text-sm font-semibold text-white transition hover:opacity-95"
                >
                  Sign in with email
                </Link>
              ) : null}
              {authError ? (
                <p className="text-sm text-red-600" role="alert">
                  {authError}
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
